// extracted by mini-css-extract-plugin
module.exports = {"root":"CardsList_root__2LnqG","cards":"CardsList_cards__pz0gJ","expiry":"CardsList_expiry__iQmnW"};